'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPlayForWork = function MdPlayForWork(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 23.4h3.4q0 2.7 1.9 4.6t4.7 2 4.7-1.9 1.9-4.7h3.4q0 4.1-2.9 7t-7.1 3-7.1-3-2.9-7z m8.4-15h3.2v9.3h5.9l-7.5 7.5-7.5-7.5h5.9v-9.3z' })
        )
    );
};

exports.default = MdPlayForWork;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/play-for-work.js
// module id = 3670
// module chunks = 168707334958949